import './Footer.css';

const Footer = () => {
	return (
		<footer className='footer-wrapper'>
			<div className='footer'>
				<p className='footer-text'>Copyright © </p>
				<p className='footer-text'>Afra Jurkiewicz</p>
			</div>
		</footer>
	);
};
export default Footer;
